module.exports = __webpack_public_path__ + "img/zhubiao@2x.32ed4003.png";